export default [
  {
    id: 1,
    question: "کدام ویژگی زیر در خرید محصولات برای شما بیشترین اهمیت را دارد ؟",
    score: "",
    options: [
      {
        name: "تنوع محصولات",
        value:"0",
        questions: [],
      },
      {
        name: "رضایت مشتریان",
        value:"1",
        questions: [],
      },
      {
        name: "قیمت مصرف کننده",
        value:"2",
        questions: [],
      },
      {
        name: "حاشیه سود",
        value:"3",
        questions: [],
      },
      {
        name: "کیفیت وبسته بندی",
        value:"4",
        questions: [],
      },
      {
        name: "ارسال به موقع",
        value:"5",
        questions: [],
      },
      {
        name: "نحوه تسویه حساب",
        value:"6",
        questions: [],
      },
      {
        name: "رضایت از کارکنان فروش",
        value:"7",
        questions: [],
      },
      {
        name: "نوع تبلیغات",
        value:"8",
        questions: [],
      },
      {
        name: "طرح های فروش",
        value:"9",
        questions: [],
      },
    ],
  },
  {
    id: 2,
    question: "کدامیک از محصولات زیردر فروشگاه شما پرفروش تر است ؟",
    score: "",
    options: [
      {
        name: "انواع محصولات لبنی",
        value:"0",
        questions: [],
      },
      {
        name: "انواع محصولات سلولزی",
        value:"1",
        questions: [],
      },
      {
        name: "انواع پنیرپیتزا",
        value:"2",
        questions: [],
      },
      {
        name: "انواع سس مایونزوکچاپ",
        value:"3",
        questions: [],
      },
      {
        name: "انواع کمپوت ومربا",
        value:"4",
        questions: [],
      },
      {
        name: "انواع رب گوجه فرنگی",
        value:"5",
        questions: [],
      },
      {
        name: "انواع آب بسته بندی",
        value:"6",
        questions: [],
      },
      {
        name: "انواع روغن های خوراکی",
        value:"7",
        questions: [],
      },
      {
        name: "انواع کنسروغیرگوشتی",
        value:"8",
        questions: [],
      },
      {
        name: "انواع محصولات آردی",
        value:"9",
        questions: [],
      },
    ],
  },
  {
    id: 3,
    question: "تاچه اندازه با محصولات تبرک آشنایی دارید ؟",
    score: "",
    options: [
      {
        name: "کم",
        questions: [],
        value:"0",
      },
      {
        name: "متوسط",
        questions: [],
        value:"1",
      },
      {
        name: "زیاد",
        questions: [],
        value:"2",
      },
      {
        name: "ندارم",
        questions: [],
        value:"3",
      },
    ],
  },
  {
    id: 4,
    question: "باکدامیک از محصولات تبرک بیشتر آشنا هستید ؟",
    score: "",
    options: [
      {
        name: "انواع محصولات لبنی",
        questions: [],
        value:"0",
      },
      {
        name: "انواع محصولات سلولزی",
        questions: [],
        value:"1",
      },
      {
        name: "انواع پنیرپیتزا",
        questions: [],
        value:"2",
      },
      {
        name: "انواع سس مایونزوکچاپ",
        questions: [],
        value:"3",
      },
      {
        name: "انواع کمپوت ومربا",
        questions: [],
        value:"4",
      },
      {
        name: "انواع رب گوجه فرنگی",
        questions: [],
        value:"5",
      },
      {
        name: "انواع آب بسته بندی",
        questions: [],
        value:"6",
      },
      {
        name: "انواع روغن های خوراکی",
        questions: [],
        value:"7",
      },
      {
        name: "انواع کنسروغیرگوشتی",
        questions: [],
        value:"8",
      },
      {
        name: "انواع محصولات آردی",
        questions: [],
        value:"9",
      },
    ],
  },
  {
    id: 5,
    question:
      "تاکنون نماینده فروش تبرک برای معرفی محصولات به فروشگاه شمامراجعه نموده است ؟",
    score: "",
    options: [
      {
        name: "صفر",
        questions: [],
        value:"0",
      },
      {
        name: "یکبار",
        questions: [],
        value:"1",
      },
      {
        name: "چندبار",
        questions: [],
        value:"2",
      },
    ],
  },
  {
    id: 6,
    question:
      "به کدام دلیل زیرتاکنون نتوانسته اید از گروه صنعتی تبرک خریدنمائید ؟",
    score: "",
    options: [
      {
        name: "عدم آشنایی کافی بامحصولات تبرک",
        questions: [],
        value:"0",
      },
      {
        name: "عدم مراجعه نماینده فروش تبرک",
        questions: [],
        value:"1",
      },
      {
        name: "عدم تمایل به همکاری با برندجدید",
        questions: [],
        value:"2",
      },
      {
        name: "عدم جذابیت طرح های فروش تبرک",
        questions: [],
        value:"3",
      },
      {
        name: "عدم حاشیه سودکافی برای خرید",
        questions: [],
        value:"4",
      },
      {
        name: "مدت اعتبارونحوه تسویه حساب",
        questions: [],
        value:"5",
      },
    ],
  },
  {
    id: 7,
    question:
      "محصولات تبرک رادربین کالاهای مشابه ، به عنوان چندبرنداول جهت خریدبه دیگران پیشنهاد می دهید ؟",
    score: "",
    options: [
      {
        name: "1 تا 3 برند",
        questions: [],
        value:"0",
      },
      {
        name: "4 تا 6 برند",
        questions: [],
        value:"1",
      },
      {
        name: "7 تا 10 برند",
        questions: [],
        value:"2",
      },
      {
        name: "بیش از 10 برند",
        questions: [],
        value:"3",
      },
      {
        name: "هیچکدام",
        questions: [],
        value:"4",
      },
    ],
  },
 
];
